<template>
  <div style="position: relative;">
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid">
      <div class="card shadow sp_card" style="margin-top: -178px;">
        <div class="sp_table-container">
          <div class="sp_table-header-cont">
            <div class="sp_header-item" style="max-width: 60px;">
              ID
            </div>
            <div
              class="sp_header-item"
              style="max-width: 105px; justify-content: space-between;"
            >
              Estado

              <i
                @click="onStatusFilter = !onStatusFilter"
                class="fas fa-filter"
                :style="{
                  color:
                    onStatusFilter || currentStatus !== 'all'
                      ? '#F54B4B'
                      : '#00000040',
                  cursor: 'pointer',
                }"
              ></i>

              <div v-if="onStatusFilter" class="sp_status-filter-cont">
                <button
                  @click="hanldeStatus('all')"
                  :class="[
                    'sp_status-option-btn',
                    currentStatus == 'all' ? 'sp_status-opt--selected' : '',
                  ]"
                >
                  Todos
                </button>
                <button
                  @click="hanldeStatus('cerrado')"
                  :class="[
                    'sp_status-option-btn',
                    currentStatus == 'cerrado' ? 'sp_status-opt--selected' : '',
                  ]"
                >
                  Cerrado
                </button>
                <button
                  @click="hanldeStatus('pendiente')"
                  :class="[
                    'sp_status-option-btn',
                    currentStatus == 'pendiente' ? 'sp_status-opt--selected' : '',
                  ]"
                >
                  Pendiente
                </button>
                <button
                  @click="hanldeStatus('cancelado')"
                  :class="[
                    'sp_status-option-btn',
                    currentStatus == 'cancelado' ? 'sp_status-opt--selected' : '',
                  ]"
                >
                  Cancelado
                </button>
              </div>
            </div>
            <div
              class="sp_header-item"
              style="flex: 2; max-width: 180px; justify-content: space-between;"
            >
              Fecha

              <div class="sp_sort-dates-cont">
                <i
                  @click="handleDate(false)"
                  class="fas fa-caret-up"
                  :style="{
                    color: statusDate === false ? '#F54B4B' : '#00000040',
                    cursor: 'pointer',
                  }"
                ></i>
                <i
                  @click="handleDate(true)"
                  class="fas fa-caret-down"
                  :style="{
                    color: statusDate === true ? '#F54B4B' : '#00000040',
                    cursor: 'pointer',
                  }"
                ></i>
              </div>
            </div>
            <div class="sp_header-item" style="max-width: 100px;">
              Hora
            </div>
            <div class="sp_header-item" style="max-width: 120px;">
              Card Code
            </div>
            <div
              class="sp_header-item"
              style="flex: 2; justify-content: space-between;"
            >
              Cliente
              <i
                @click="onSearchByName = !onSearchByName"
                class="fas fa-search"
                :style="{
                  color:
                    onSearchByName || filterName !== ''
                      ? '#F54B4B'
                      : '#00000040',
                  cursor: 'pointer',
                }"
              ></i>

              <div v-if="onSearchByName" class="sp_filter-search-container">
                <input
                  v-model="filterName"
                  @input="handleSearchby"
                  placeholder="Buscar por nombre"
                />
                <button
                  @click="
                    onSearchByName = false;
                    filterName = '';
                    customDataCopy = customerData;
                  "
                >
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
            <div class="sp_header-item" style="flex: 3">
              Notas
            </div>
            <div class="sp_header-item">
              Adjuntos
            </div>
            <div class="sp_header-item">
              Acciones
            </div>
          </div>
          <div v-if="customerData && !loading" class="sp_table-rows-cont">
            <div
              v-for="(item, index) in customDataCopy"
              :key="index"
              class="sp_table-row-cont"
            >
              <div class="sp_table-row-item" style="max-width: 60px;">
                {{ item.id }}
              </div>
              <div
                class="sp_table-row-item"
                :class="[item.status]"
                style="max-width: 105px;"
              >
                {{ capitalizeFirstLetter(item.status) }}
              </div>
              <div class="sp_table-row-item" style="flex: 2; max-width: 180px;">
                {{ formatDate(item.creationdate) }}
              </div>
              <div class="sp_table-row-item" style="max-width: 100px;">
                {{ formatTime12h(item.creationtime) }}
              </div>
              <div class="sp_table-row-item" style="max-width: 120px;">
                {{ item.cardcode }}
              </div>
              <div class="sp_table-row-item" style="flex: 2">
                {{ item.cardname }}
              </div>
              <div class="sp_table-row-item" style="flex: 3">
                {{ item.notes }}
              </div>
              <button
                :disabled="getAttachments(item).length === 0"
                @click="handleDropDown(item)"
                class="sp_table-row-item sp_attachment-button"
              >
                <div><i class="fas fa-paperclip"></i> Adjuntos</div>
                <i class="fas fa-caret-down"></i>
                <div
                  v-if="openDropDown && currentRow === item.id"
                  class="sp_dropdown-cont"
                >
                  <a
                    target="_blank"
                    :href="att"
                    class="sp_dropdown-item"
                    v-for="(att, index) in getAttachments(item)"
                    :key="index"
                  >
                    Adjunto {{ index + 1 }}
                  </a>
                </div>
              </button>
              <div
                class="sp_table-row-item"
                style="display: flex; align-items: center; justify-content: center; gap: 8px;"
              >
                <button
                  :disabled="
                    item.status === 'cerrado' || item.status === 'cancelado'
                  "
                  @click="(cancelModal = true), (currentRow = item.id)"
                  class="sp_action-button sp_cancel-button"
                  :class="[
                    item.status === 'cerrado' || item.status === 'cancelado'
                      ? 'sp_disabled-button'
                      : '',
                  ]"
                >
                  Cerrar
                </button>
                <button
                  @click="handleDrawer(item)"
                  class="sp_action-button"
                  style="max-width: 30px;"
                >
                  <i class="fas fa-angle-double-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="sp_loading-cont" v-else>Cargando ...</div>
        </div>
      </div>
    </div>
    <div
      class="sp_selected-row-drawer"
      :style="{
        right: openDrawer && currentRow ? '0px' : '-1000px',
      }"
    >
      <div v-if="currentRow" class="sp_drawer-container">
        <div class="sp_drawer-header">
          <span
            ><b class="sp_head-title-id">{{ currentRow }}</b> SOLICITUD DE
            PEDIDO</span
          >

          <Button
            @click="(openDrawer = false), (currentRow = null)"
            class="sp_close-drawer-button"
          >
            <i class="fas fa-times"></i>
          </Button>
        </div>
        <div class="sp_table-container">
          <div class="sp_table-header-cont">
            <div class="sp_header-item" style="max-width: 50px;">
              ID
            </div>
            <div class="sp_header-item" style="flex: 1">
              Código
            </div>
            <div class="sp_header-item" style="flex: 2">
              Nombre
            </div>
            <div class="sp_header-item">
              Cantidad
            </div>
            <div class="sp_header-item">
              Rollos
            </div>
            <div class="sp_header-item">
              Precio
            </div>
            <div class="sp_header-item" style="flex: 2;">
              Notas
            </div>
          </div>
          <div v-if="itemsData" class="sp_table-rows-cont">
            <div
              v-for="(item, index) in itemsData"
              :key="index"
              class="sp_table-row-cont sp_item-row-table"
            >
              <div class="sp_table-row-item" style="max-width: 50px;">
                {{ item.id }}
              </div>
              <div class="sp_table-row-item" style="flex: 1">
                {{ item.itemcode }}
              </div>
              <div class="sp_table-row-item" style="flex: 2">
                {{ item.itemname }}
              </div>
              <div class="sp_table-row-item">
                {{ item.quantity }}
              </div>
              <div class="sp_table-row-item">
                {{ item.rolls }}
              </div>
              <div class="sp_table-row-item" >
                {{ formatCurrency(item.price) }}
              </div>
              <div class="sp_table-row-item" style="flex: 2">
                {{ item.notes }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="cancelModal && currentRow" class="sp_pop-up-background">
      <div class="sp_popup-container">
        <!-- <img
            src="../assets/warning.png"
            alt=""
            style="max-width: 150px; margin-bottom: 16px;"
          /> -->
        <span
          >Estas por cerrar el pedido con ID: <b>{{ currentRow }}</b></span
        >
        <span><b>¿Estas seguro que desas cerrarlo?</b></span>
        <div class="sp_popup-row">
          <button @click="(currentRow = null), (cancelModal = false)">
            Cancelar
          </button>
          <button @click="handelCancel(currentRow)">Cerrar pedido</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      BASE_URL: process.env.VUE_APP_BASE_URL,
      BASE_HANA: process.env.VUE_APP_HANA_URL,
      loading: false,
      onLoad: false,
      cardCode: null,
      customerData: null,
      currentRow: null,
      openDropDown: false,
      openDrawer: false,
      itemsData: null,
      cancelModal: false,
      currentStatus: "all",
      onStatusFilter: false,
      onSearchByName: false,
      filterName: "",
      statusDate: null,
      customDataCopy: [],
      itemsListCopy: [],
      itemsList: [],
      itemsSelected: [],
    };
  },
  mounted() {
    this.loading = true;
    const sql = {
      sql: `SELECT * FROM order_drafts`,
    };
    Promise.all([axios.post(`${this.BASE_HANA}/api/sb/general/query`, sql)])
      .then(([response]) => {
        console.log(response);
        this.customerData = response.data.sort((a, b) => b.id - a.id);
        this.customDataCopy = this.customerData;
        this.loading = false;
      })
      .catch((err) => {
        console.error("Error en alguna de las peticiones:", err);
      });
  },
  methods: {
    formatCurrency(value) {
      if (isNaN(value)) return "$0.00 MXN";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      }).format(value);
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
      // Ej: "12 de junio de 2025"
    },
    formatTime12h(timeStr) {
      const [hours, minutes, seconds] = timeStr.split(":");
      const date = new Date();
      date.setHours(hours, minutes, seconds);
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      // Ej: "1:00 AM"
    },
    capitalizeFirstLetter(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getAttachments(obj) {
      return Object.keys(obj)
        .filter((key) => key.startsWith("attachment") && obj[key])
        .map((key) => obj[key]);
    },
    handleDropDown(item) {
      if (item.id === this.currentRow) {
        this.currentRow = null;
        this.openDropDown = false;
      } else {
        this.currentRow = item.id;
        this.openDropDown = true;
      }
    },
    handleDrawer(item) {
      this.currentRow = item.id;
      this.openDrawer = true;
      // console.log(`${this.BASE_HANA}/api/sb/order_drafts/${item.id}/items`);
      axios
        .get(`${this.BASE_HANA}/api/sb/order_drafts/${item.id}/items`)
        .then((response) => {
          this.itemsData = response.data;
          // console.log(response);
        })
        .catch((err) => {
          console.error(err);
        });
    },

    hanldeStatus(status) {
      this.currentStatus = status;
      this.statusDate = null;
      if (status === "all") {
        this.customDataCopy = this.customerData;
      } else {
        this.customDataCopy = this.customerData.filter(
          (item) => item.status === status
        );
      }
      this.onStatusFilter = false;
      this.filterName = "";
      this.onSearchByName = false;
    },
    handleDate(sortDate) {
      this.statusDate = this.statusDate === sortDate ? null : sortDate;
      this.currentStatus = "all";
      this.filterName = "";
      this.onSearchByName = false;
      if (this.statusDate === true) {
        this.customDataCopy = [...this.customerData].sort(
          (a, b) => new Date(a.creationdate) - new Date(b.creationdate)
        );
      } else if (this.statusDate === false) {
        this.customDataCopy = [...this.customerData].sort(
          (a, b) => new Date(b.creationdate) - new Date(a.creationdate)
        );
      } else {
        this.customDataCopy = [...this.customerData];
      }
    },
    handleSearchby() {
      this.currentStatus = "all";
      this.onStatusFilter = false;
      this.customDataCopy = this.customerData.filter((item) =>
        item.cardname.toLowerCase().includes(this.filterName.toLowerCase())
      );
    },
    getCreationDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // +1 porque los meses van de 0 a 11
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getCreationTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },

    handelCancel(id) {
      const data = {
        status: "cerrado",
      };
      axios
        .patch(`${this.BASE_HANA}/api/sb/order_drafts/${id}`, data)
        .then(() => {
          this.reloadItems();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reloadItems() {
      const sql = {
        sql: `SELECT * FROM order_drafts`,
      };
      axios
        .post(`${this.BASE_HANA}/api/sb/general/query`, sql)
        .then((response) => {
          this.customerData = response.data.sort((a, b) => b.id - a.id);
          this.customDataCopy = this.customerData
          this.note_message = null;
          this.openDrawer = false;
          this.onNewDraft = false;
          this.cancelModal = false;
          this.currentRow = null;
          this.onLoad = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style scoped>
.sp_card {
  min-height: 80vh;
  border-radius: 16px;
  overflow: hidden;
}

.sp_table-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
}

.sp_table-header-cont {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  height: 35px;
  background-color: #e9ecef;
  gap: 12px;
  padding: 0px 12px;
  box-sizing: border-box;
}

.sp_header-item {
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  border-right: 2px solid #00000010;
  /* padding: 0px 16px; */
  padding-right: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
}

.sp_header-item .fa-filter,
.sp_header-item .fa-search {
  font-size: 10px;
  color: #00000040;
}

.sp_header-item:last-of-type {
  border: none;
}

.sp_status-filter-cont {
  position: absolute;
  left: -14px;
  top: 30px;
  width: 130px;
  background-color: #fff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 8px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}

.sp_sort-dates-cont {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  color: #00000040;
}

.sp_status-option-btn {
  align-self: stretch;
  border: none;
  font-size: 14px;
  border-radius: 6px;
  padding: 4px 0px;
  background-color: transparent;
  transition: all 0.3s ease;
}

.sp_status-option-btn:hover {
  background-color: #f54b4b40;
}

.sp_status-option-btn:active,
.sp_status-option-btn:hover,
.sp_status-option-btn:focus {
  outline: none;
}

.sp_status-opt--selected,
.sp_status-opt--selected:hover {
  background-color: #f54b4b;
  color: #fff;
}

.sp_filter-search-container {
  position: absolute;
  left: -10px;
  top: 30px;
  width: 300px;
  height: 45px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px;
  box-sizing: border-box;
  gap: 6px;
}

.sp_filter-search-container button {
  border-radius: 8px;
  border: none;
  height: 30px;
  width: 30px;
  max-height: 30px;
  min-width: 30px;
  background-color: #dcdcdc30;
  font-size: 12px;
  color: #00000050;
  transition: all 0.3s ease;
}

.sp_filter-search-container button:hover {
  background-color: #cb334b;
  color: #fff;
}

.sp_filter-search-container button:hover,
.sp_filter-search-container button:active,
.sp_filter-search-container button:focus,
.sp_filter-search-container input:hover,
.sp_filter-search-container input:active,
.sp_filter-search-container input:focus {
  outline: none;
}

.sp_filter-search-container input {
  align-self: stretch;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #dcdcdc80;
  padding-left: 6px;
}

.sp_filter-search-container input::placeholder {
  color: #00000030;
  font-style: italic;
}

.sp_table-rows-cont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  max-height: 80vh;
  min-height: 80vh;
  overflow: auto;
}

.sp_table-row-cont {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  height: 35px;
  max-height: 35px;
  /* min-height: 55px; */
  gap: 12px;
  padding: 0px 12px;
}

.sp_table-row-cont:nth-child(even) {
  background-color: #e9ecef40;
}

.sp_table-row-cont:nth-child(odd) {
  background-color: #ffffff;
}

.sp_table-row-item {
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  /* padding: 0px 16px; */
  box-sizing: border-box;
}

.cerrado,
.pendiente,
.cancelado {
  text-align: center;
  border-radius: 99px;
  background-color: #d9f7be80;
  border: 1px solid #52c41a80;
  color: #52c41a;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pendiente {
  background-color: #fff7e680;
  border: 1px solid #faad1480;
  color: #faad14;
}

.cancelado {
  background-color: #f9b6c080;
  border: 1px solid #cb334b80;
  color: #cb334b;
}

.sp_attachment-button {
  text-align: center;
  border-radius: 99px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  background-color: #e9ecef80;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.20); */
  cursor: pointer;
  transition: all 0.3s ease;
  height: 22px;
  position: relative;
  border: none;
}

.sp_attachment-button:active,
.sp_attachment-button:focus {
  outline: none;
}

.sp_attachment-button:hover {
  background-color: #f6f9fc;
}

.sp_action-button {
  /* border: 1px solid; */
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  font-weight: 600;
  background-color: #e9ecef80;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.20); */
  cursor: pointer;
  transition: all 0.3s ease;
  height: 22px;
  flex: 1;
  border: none;
  /* max-width: 150px; */
}

.sp_action-button:active,
.sp_action-button:focus {
  outline: none;
}

.sp_action-button:hover {
  background-color: #cb334b;
  color: #fff;
}

.sp_cancel-button:hover {
  background-color: #52c41a;
}

.sp_disabled-button:hover {
  background-color: #e9ecef80;
  color: #00000040;
}

.fa-paperclip {
  font-size: 12px;
  margin-right: 2px;
}

.sp_dropdown-cont {
  width: 200px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background-color: #fff;
  position: absolute;
  z-index: 99;
  top: 40px;
  left: 0px;
  border-radius: 12px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}

.sp_dropdown-item {
  width: 100%;
  height: 30px;
  border-radius: 99px !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #e9ecef;
  border-radius: 99px;
  cursor: pointer;
}

.sp_selected-row-drawer {
  width: 950px;
  height: 100vh;
  max-height: 100vh;
  padding-bottom: 36px;
  overflow: auto;
  position: fixed;
  top: 0px;
  background-color: #fff;
  box-shadow: -12px 0px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 98;
}

.sp_drawer-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  /* gap: 16px; */
  align-self: stretch;
}

.sp_drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
  font-size: 18px;
  font-weight: 600;
}

.sp_close-drawer-button {
  height: 30px;
  width: 30px;
  background-color: #e9ecef;
  border: none;
  border-radius: 99px;
  transition: all 0.3s ease;
  font-size: 12px;
}

.sp_close-drawer-button:hover {
  background-color: #cb334b;
  color: #fff;
}

.sp_head-title-id {
  background-color: #cb334b;
  padding: 4px 8px;
  margin-right: 4px;
  color: #fff;
}

.sp_item-row-table {
  height: auto;
  min-height: 80px;
  line-height: 1.1;
  padding-top: 8px;
  padding-bottom: 8px;
}


.sp_loading-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: 30vh;
  font-weight: 600;
}

.sp_pop-up-background {
  width: 100%;
  height: 100vh;
  background-color: #00000050;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 156px;
}

.sp_popup-container {
  /* width: 650px; */
  /* height: 300px; */
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 36px 86px;
  font-size: 18px;
  color: #000;
  font-weight: 400;
  line-height: 1.2;
}

.sp_popup-row {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  gap: 16px;
  margin-top: 24px;
}

.sp_popup-row button {
  border: none;
  padding: 8px 18px;
  border-radius: 99px;
  font-size: 16px;
  font-weight: 600;
}

.sp_popup-row button:last-of-type {
  background-color: #52c41a;
  color: #ffffff;
}

.sp_popup-row button:active,
.sp_popup-row button:focus {
  outline: none;
}
</style>
